import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: "",
  error: "",
  loading: false,
  isUserLogout: false
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state :any, action :any) {
      state.error = action.payload;
      state.loading = false;
      state.isUserLogout = false;
    },
    loginSuccess(state :any, action :any) {
      state.user = action.payload
      state.loading = false;
    },
    logoutUserSuccess(state :any, action :any) {
      state.isUserLogout = true
    },
    reset_login_flag(state :any) {
      state.error = ""
    }
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag
} = loginSlice.actions

export default loginSlice.reducer;